module.exports = __webpack_public_path__ + "static/media/uzb.80e9ad67.svg";